import config from '../config';
import { RezenObjectTypeEnum } from '../openapi/yada';

export const getSSEUrl = (borrowerId: string) => {
  return `${config.apiBasePath.yada}/api/v1/comments/sse-subscribe?containerType=${RezenObjectTypeEnum.Borrower}&containerId=${borrowerId}`;
};
